import t from"@emotion/styled";import{setColor as r,setRadius as o}from"../../utils/generateStyles.js";const a=t.div`
  label: skeleton;
  ${()=>r("gray-30","backgroundColor")};
  ${i=>o(i.isCircle?"full":i.radius)};
  ${i=>({width:i.isCircle?i.height:i.width,height:i.height,marginTop:i.mt||0,marginBottom:i.mb||0,marginLeft:i.ml||0,marginRight:i.mr||0})};
  ${i=>i.isVisible?{"@keyframes pulse":{"50%":{opacity:"0.5"}},animation:"pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",["& > .child-outer"]:{opacity:0}}:{backgroundColor:"transparent"}}
`;export{a as default};
